import { LoadingController } from "ionic-angular";

export class LoaderHelper {

    constructor() { }

    static loader: any;

    public static Show(loadingCtrl: LoadingController) {
        this.loader = loadingCtrl.create({
            content: 'Please wait...',
        });
        this.loader.present();
    }

    public static Hide() {
        this.loader.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/helpers/loader-helper.ts